export default {
  directors: `profile/directors`,
  update: `profile/directors/update`,
  remove: `profile/directors/remove`,
};
